<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation scrollable
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          定型コース検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid class="ma-0 pa-2">
          <dd-sub-header>
            <span>以下の検索条件で絞り込む</span>
            <span style="float: right;">
              <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
              <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
              <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
              </dd-transparent-button>
            </span>
          </dd-sub-header>
          <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
            <v-row no-gutters>
              <v-col :cols="2" class="px-1">
                <dd-text-box
                  label="コースNo"
                  v-model="conditions.teikeiCourseNo"
                  ref="teikeiCourseNo"
                  :length="50"
                  :valueType="Ctrls.InputTypes.Number"/>
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-text-box
                  label="コース名称"
                  v-model="conditions.teikeiCourseNm"
                  ref="teikeiCourseNm"
                  :length="50"
                  :valueType="Ctrls.InputTypes.Free"
                />
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-code-text-box
                  label="得意先コード/名称"
                  v-model="conditions.tokuisakiCd"
                  ref="tokuisakiCd"
                  :length="100"
                  :required="false"
                  :valueType="Ctrls.InputTypes.Free"
                  titleText="取引先マスタ検索"
                  :headerList="mstTorihikisakiHeader"
                  item-value="torihikisakiCd"
                  item-text="torihikisakiNm"
                  :itemList="filteredMstTokuisakiList"
                />
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-code-text-box
                  label="担当営業所コード/名称"
                  v-model="conditions.tantoEigyoshoCd"
                  ref="tantoEigyoshoCd"
                  :required=false
                  :length=100
                  :valueType="Ctrls.InputTypes.Free"
                  :itemList="filteredEigyoshoList"
                  titleText="営業所検索"
                  item-value="eigyoshoCd"
                  item-text="eigyoshoNm"
                  :headerList="mstEigyoshoHeader"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col :cols="2" class="px-1">
                <dd-text-box
                  label="客先注文番号"
                  v-model="conditions.chumonNo"
                  ref="chumonNo"
                  :length="20"
                  :valueType="Ctrls.InputTypes.Free"
                />
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-code-text-box
                  label="発地コード/名称"
                  v-model="conditions.hatsuchiCd"
                  ref="hatsuchiCd"
                  :length="100"
                  :required="false"
                  :valueType="Ctrls.InputTypes.Free"
                  titleText="発着地マスタ検索"
                  :headerList="mstHacchakuchiHeaders"
                  item-value="hacchakuchiCd"
                  item-text="hacchakuchiNm"
                  :itemList="filteredHacchakuchiList"
                />
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-code-text-box
                  label="着地コード/名称"
                  v-model="conditions.chakuchiCd"
                  ref="chakuchiCd"
                  :length="100"
                  :required="false"
                  :valueType="Ctrls.InputTypes.Free"
                  titleText="発着地マスタ検索"
                  :headerList="mstHacchakuchiHeaders"
                  item-value="hacchakuchiCd"
                  item-text="hacchakuchiNm"
                  :itemList="filteredHacchakuchiList"
                />
              </v-col>
            </v-row>
            <v-row class="mt-2" justify="center">
              <dd-custom-button
                :rounded="true"
                :minWidth="200"
                :large="true"
                @click="onSearchButtonClick">
                検索をする
              </dd-custom-button>
              <a class="condition-clear" @click="onClearButtonClick">
                条件をクリア
              </a>
            </v-row>
          </div>

          <div class="px-1 py-2" v-if="filteredRows.length > 0">
            <v-row no-gutters>
              <v-col :cols="2" class="px-1">
                <span class="search-number">{{ filteredRows.length }}</span>件 の検索結果
              </v-col>
              <v-col :cols="2" class="pt-2">
                <a
                  class="condition-clear-bottom"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </v-col>
              <v-col :cols="2" v-if="dialogMode === '1'">
                <dd-custom-button
                  :rounded="false"
                  :minWidth="200"
                  :large="true"
                  :color="'#60798b'"
                  :disabled="isSelectButtonDisabled"
                  @click="onCreateExec">
                  選択したコースで受注を作成
                </dd-custom-button>
              </v-col>
              <v-col :cols="3" class="mt-2">
                <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
              </v-col>
            </v-row>

            <hr class="section-line mb-2">

            <v-row no-gutters justify="end">
              <v-col :cols="6" />
              <v-col :cols="6">
                <v-row no-gutters justify="end">
                  <dd-select-items-per-page
                    ref="pagination1"
                    :itemsPerPage.sync="itemsPerPage"
                    :currentPage.sync="page"
                    :items="filteredRows"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"
                  />
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="filteredRows"
                :custom-filter="filtering"
                :search="searchText"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                :showSelect="dialogMode === '1'"
                v-model="selected"
                @dblclick:row="onRowDoubleClick"
                no-data-text="対象データはありません"
                fixed-header
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:[`item.actions`]="{item}" v-if="dialogMode !== '1'">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </template>
                </template>
              </v-data-table>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3">
          <v-col :cols="6">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :cols="6" v-if="filteredRows.length > 0">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import Swal from 'sweetalert2'

import { mapGetters } from 'vuex'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdPackageTeikeiCourseSearchDialog',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdCodeTextBox,
    DdSubHeader,
    DdTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 1行選択
     */
    singleSelect: {
      type: Boolean,
      default: true
    },
    /**
     * 実行モード(0:選択モード,1:追加モード)
     */
    dialogMode: {
      type: String,
      default: '0'
    },
    param: {
      HaishaYmd: '',
      startHM: ''
    }
  },
  data: () => ({
    isConditionHide: false,
    conditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tokuisakiCd: '',
      chumonNo: '',
      tantoEigyoshoCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },
    addConditions: {
      HaishaYmd: '',
      startHM: '',
      unkoYmd: '',
      hatsuchiYmd: ''
    },
    // フィルター定義 －－ここから－－
    teikeiCourseFilterConditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tokuisakiCd: '',
      tantoEigyoshoCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },
    // フィルター定義 －－ここまで－－
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    // 一覧制御用
    selected: [],
    itemsPerPage: 25,
    page: 1
    /*
     *
     */
  }),

  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '定型コース検索')
    this.mstEigyoshoHeader = header.mstEigyoshoHeaders
    this.mstTorihikisakiHeader = header.mstTorihikisakiHeaders
    this.mstHacchakuchiHeaders = header.mstHacchakuchiHeaders
  },
  mounted () {
    this.initialize()
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    filteredRows () {
      const self = this
      return this.rows.filter(function (elem) {
        return self.isTeiekiCourseSearchCheck(elem)
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selected.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.41
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKoteiKamotsuNoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: '', value: 'actions', align: 'center' },
              { text: '選択', value: 'select', align: 'center' },
              // { text: '会社CD', value: 'kaishaCd' },
              { text: '定型コースNo', value: 'teikeiCourseNo' },
              { text: '定型コース名称', value: 'teikeiCourseNm' },
              { text: '', value: 'actions', align: 'center' },
              { text: 'コースNo', value: 'teikeiCourseNo' },
              { text: 'コース名称', value: 'teikeiCourseNm' },
              { text: '得意先名称', value: 'tokuisakiDisp' },
              { text: '担当営業所', value: 'tantoEigyoshoDisp' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '商品', value: 'hinmeiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発時刻', value: 'hatsuchiHmsDisp' },
              { text: '経由地１', value: 'keiyuchiId1Disp' },
              { text: '経由地２', value: 'keiyuchiId2Disp' },
              { text: '経由地３', value: 'keiyuchiId3Disp' },
              { text: '経由地４', value: 'keiyuchiId4Disp' },
              { text: '経由地５', value: 'keiyuchiId5Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着時刻', value: 'chakuchiHmsDisp' },
              { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '請求車種', value: 'seikyuShashuSbtNm' },
              { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
              { text: '走行距離', value: 'yoteiSokoKyoriDisp', align: 'end' },
              { text: '走行時間', value: 'yoteiSagyoJikanDisp', align: 'center' },
              { text: '数量', value: 'juchuSuryo', align: 'end' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '重量', value: 'juchuJuryo', align: 'end' },
              { text: '単価', value: 'tanka', align: 'end' },
              { text: '運賃', value: 'kihonUnchin', align: 'end' },
              { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
              { text: '運賃(他)', value: 'unchinHokaKingaku', align: 'end' },
              { text: '保管料', value: 'hokanKingaku', align: 'end' },
              { text: '荷役料', value: 'niekiKingaku', align: 'end' },
              { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
              { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
              { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
              { text: '待機時間', value: 'taikiJikanDisp', align: 'end' },
              { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
              { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
              { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
              { text: '運賃他(非)', value: 'unchinHokaHikazei', align: 'end' },
              { text: '立替金(非)', value: 'tatekaekinHikazei', align: 'end' },
              { text: '割増対象時間', value: 'warimashiTaishoJikanDisp', align: 'center' },
              { text: '割増単価(時間)', value: 'warimashiJikanTanka', align: 'end' },
              { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
              { text: '割増距離', value: 'warimashiTaishoKyoriDisp', align: 'end' },
              { text: '割増単価(距離)', value: 'warimashiKyoriTanka', align: 'end' },
              { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
              { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
              { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
              { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
              { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
              { text: '運行手当', value: 'sagyoinTeateKingaku1', align: 'end' },
              { text: '高速ETC', value: 'sharyoKeihiHiwayEtc', align: 'end' },
              { text: '高速現金', value: 'sharyoKeihiHiwayGenkin', align: 'end' },
              { text: 'フェリー', value: 'sharyoKeihiFerry', align: 'end' },
              { text: '請求用備考', value: 'seikyuBiko' },
              { text: '連絡用備考', value: 'renrakuBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKoteiKamotsuNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKoteiKamotsuNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }

      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      this.initBindVariables()
      this.searchText = ''
      this.selected = []
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', item)
      this.initBindVariables()
      this.searchText = ''
      this.selected = []
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.teikeiCourseFilterConditions = Object.assign({}, this.conditions)
    },
    isTeiekiCourseSearchCheck (elem) {
      const self = this
      return (!self.teikeiCourseFilterConditions.teikeiCourseNo || String(elem.teikeiCourseNo).indexOf(self.teikeiCourseFilterConditions.teikeiCourseNo) !== -1) &&
      (!self.teikeiCourseFilterConditions.teikeiCourseNm || elem.teikeiCourseNm.indexOf(self.teikeiCourseFilterConditions.teikeiCourseNm) !== -1) &&
      (!self.teikeiCourseFilterConditions.tokuisakiCd || elem.tokuisakiCd === self.teikeiCourseFilterConditions.tokuisakiCd) &&
      (!self.teikeiCourseFilterConditions.chumonNo || elem.chumonNo === self.teikeiCourseFilterConditions.chumonNo) &&
      (!self.teikeiCourseFilterConditions.tantoEigyoshoCd || elem.tantoEigyoshoCd === self.teikeiCourseFilterConditions.tantoEigyoshoCd) &&
      (!self.teikeiCourseFilterConditions.hatsuchiCd || elem.hatsuchiCd === self.teikeiCourseFilterConditions.hatsuchiCd) &&
      (!self.teikeiCourseFilterConditions.chakuchiCd || elem.chakuchiCd === self.teikeiCourseFilterConditions.chakuchiCd)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = this.itemList
        this.selected = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', false)
      console.log('emited', this.showDialog)
      // this.clear(false)
      this.initBindVariables()
      this.searchText = ''
      this.selected = []
    },
    searchValidate: function () {
      return true
    },
    // --------------------------------------------------------------------------------
    // 定型追加処理
    // --------------------------------------------------------------------------------
    onCreateExec: function (e) {
      this.onCreateExecAction()
      console.log(e)
    },
    onCreateExecAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            var rex = data.payload
            if (rex !== '') {
              this.showError(rex)
            } else {
              this.showSuccess('定型からの受注作成が完了しました')
              this.$emit('exec', true)
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      var itemlist = []
      this.selected.forEach(p => {
        itemlist = itemlist.concat(p.teikeiCourseNo)
      })
      console.log('onCreateExecAction foreachOut', itemlist)
      var addData = {
        kaishaCd: this.selected[0].kaishaCd,
        startHM: this.addConditions.startHM,
        unkoYmd: this.addConditions.unkoYmd,
        hatsuchiYmd: this.addConditions.hatsuchiYmd,
        teikeiCourseNo: itemlist.join(',')
      }
      const f = this.HttpClient.post('/api/v1/D2Plmd0020/CopyTeikei', addData)
      return f
    },
    registerValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.headers = [
        { text: '会社CD', value: 'kaishaCd' },
        { text: '定型コースNo', value: 'teikeiCourseNo' },
        { text: '定型コース名称', value: 'teikeiCourseNm' },
        { text: 'コースNo', value: 'teikeiCourseNo' },
        { text: 'コース名称', value: 'teikeiCourseNm' },
        { text: '得意先名称', value: 'tokuisakiDisp' },
        { text: '担当営業所', value: 'tantoEigyoshoDisp' },
        { text: '客先注文番号', value: 'chumonNo' },
        { text: '商品', value: 'hinmeiDisp' },
        { text: '発地', value: 'hatsuchiDisp' },
        { text: '発時刻', value: 'hatsuchiHmsDisp' },
        { text: '経由地１', value: 'keiyuchiId1Disp' },
        { text: '経由地２', value: 'keiyuchiId2Disp' },
        { text: '経由地３', value: 'keiyuchiId3Disp' },
        { text: '経由地４', value: 'keiyuchiId4Disp' },
        { text: '経由地５', value: 'keiyuchiId5Disp' },
        { text: '着地', value: 'chakuchiDisp' },
        { text: '着時刻', value: 'chakuchiHmsDisp' },
        { text: '往復種別', value: 'ohfukuSbtNm' },
        { text: '請求車種', value: 'seikyuShashuSbtNm' },
        { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
        { text: '走行距離', value: 'yoteiSokoKyoriDisp', align: 'end' },
        { text: '走行時間', value: 'yoteiSagyoJikanDisp', align: 'center' },
        { text: '数量', value: 'juchuSuryo', align: 'end' },
        { text: '単位', value: 'unitKbnNm' },
        { text: '重量', value: 'juchuJuryo', align: 'end' },
        { text: '単価', value: 'tanka', align: 'end' },
        { text: '運賃', value: 'kihonUnchin', align: 'end' },
        { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
        { text: '運賃(他)', value: 'unchinHokaKingaku', align: 'end' },
        { text: '保管料', value: 'hokanKingaku', align: 'end' },
        { text: '荷役料', value: 'niekiKingaku', align: 'end' },
        { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
        { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
        { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
        { text: '待機時間', value: 'taikiJikanDisp', align: 'end' },
        { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
        { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
        { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
        { text: '運賃他(非)', value: 'unchinHokaHikazei', align: 'end' },
        { text: '立替金(非)', value: 'tatekaekinHikazei', align: 'end' },
        { text: '割増対象時間', value: 'warimashiTaishoJikanDisp', align: 'center' },
        { text: '割増単価(時間)', value: 'warimashiJikanTanka', align: 'end' },
        { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
        { text: '割増距離', value: 'warimashiTaishoKyoriDisp', align: 'end' },
        { text: '割増単価(距離)', value: 'warimashiKyoriTanka', align: 'end' },
        { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
        { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
        { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
        { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
        { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
        { text: '運行手当', value: 'sagyoinTeateKingaku1', align: 'end' },
        { text: '高速ETC', value: 'sharyoKeihiHiwayEtc', align: 'end' },
        { text: '高速現金', value: 'sharyoKeihiHiwayGenkin', align: 'end' },
        { text: 'フェリー', value: 'sharyoKeihiFerry', align: 'end' },
        { text: '請求用備考', value: 'seikyuBiko' },
        { text: '連絡用備考', value: 'renrakuBiko' }
      ]
      if (this.dialogMode !== '1') {
        const targetRowIndex = this.headers.findIndex(elem => {
          return elem.value === 'kaishaCd'
        })
        this.headers.splice(targetRowIndex, 0, { text: '', value: 'actions', align: 'center' })
      }
      this.rows = this.itemList
      this.conditions = {
        teikeiCourseNo: '',
        teikeiCourseNm: '',
        tokuisakiCd: '',
        chumonNo: '',
        tantoEigyoshoCd: '',
        hatsuchiCd: '',
        chakuchiCd: ''
      }
      this.selected = []
      this.addConditions = {
        startHM: this.param.startHM,
        unkoYmd: this.param.HaishaYmd,
        hatsuchiYmd: this.param.HaishaYmd
      }
      this.teikeiCourseFilterConditions = Object.assign({}, this.conditions)
    },
    // ダイアログメッセージ
    showError: function (msg) {
      Swal.fire({
        icon: 'error',
        html: msg
      })
    },
    showSuccess: function (msg) {
      Swal.fire({
        icon: 'success',
        html: msg
      })
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      const self = this
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        self.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        self.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      const self = this
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        self.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        self.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 520 !important;
}
</style>
